<div #part1>
  <div class="top">
    <div style="width: 45%">
      <h4 class="title">
        {{ variables.combinatedResult }} {{ combinedData.project }} -
        {{ combinedData.name }}
      </h4>
      <h5>
        {{ variables.levelCriticality }}:
        <span class="orange-class">
          {{
            combinedData.resultEstimates.criticality < 0.3
              ? variables.low1
              : combinedData.resultEstimates.criticality >= 0.3 &&
                  combinedData.resultEstimates.criticality < 0.5
                ? variables.medium1
                : combinedData.resultEstimates.criticality >= 0.5 &&
                    combinedData.resultEstimates.criticality < 0.7
                  ? variables.high1
                  : variables.critic
          }}
        </span>
      </h5>
    </div>
  </div>
</div>

<hr>

  <div class="estimate-result mt-5" id="result">
    <div class="estimate-result-total" #part6>
      <mat-table [dataSource]="totalDataSource" multiTemplateDataRows class="mat-elevation-z8 mat-table-result mat-table-custom mt-3">
        <ng-container matColumnDef="name">
          <th class="flex-basis-l th-custom text-size" *matHeaderCellDef>
            <div class="summary-cell">
              <span>{{variables.result}}</span>
              @if (hasExpandableRows()) {
              <button mat-icon-button class="custom-button" (click)="toggleAllDetailTables()">
                <mat-icon>{{areAllDetailTablesExpanded() ? 'expand_less' : 'expand_more'}}</mat-icon>
              </button>
              }
            </div>
          </th>
          <td class="flex-basis-l td-custom" *matCellDef="let element">
            <div class="summary-cell">
              <span
                [matTooltip]="element?.id === 8 ? variables.riskRowTooltip : element?.id === 4 ? variables.macroRowTooltip : ''"
                [matTooltipDisabled]="![4, 8].includes(element?.id)"
                matTooltipPosition="right">{{element.name}}</span>
              @if (checkButton(element.name)) {
              <button mat-icon-button class="custom-button" (click)="toggleDivVisibility(element.id)">
                <mat-icon>{{isParentRowExpanded(element) ? 'expand_less' : 'expand_more'}}</mat-icon>
              </button>
              }
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let element" class="expanded-detail-cell">
            @if (isParentRowExpanded(element)) {
            <div class="detail-panel">

                    @if (hasCosts) {
                      <div class="detail-flex-row detail-flex-header">
                                    @for (column of getExpandedColumns(element); track $index; let isLast = $last) {
                                    <div class="detail-col-header"
                                        [class.detail-col-first]="$index === 0"
                                        [class.flex-15]="$index > 0"
                                        [class.text-end]="$index > 3 && $index != 6"
                                        [style.flex-basis]="$index == 6? '20%':null"
                                        [style.padding-left]="$index === 6? '8rem': $index < 6? '0.5rem': null"
                                        [class.dummy-cell]="column === 'dummy'">
                                      {{getExpandedHeader(element, column)}}
                                    </div>
                                    }
                      </div>
                      @for (detail of getExpandedRows(element); track $index) {
                        <div class="detail-flex-row">
                          @for (column of getExpandedColumns(element); track $index; let isLast = $last) {
                          <div class="detail-col-cell"
                              [class.detail-col-first]="$index === 0"
                              [class.flex-15]="$index > 0"
                              [class.text-end]="$index > 3 && $index != 6"
                              [style.flex-basis]="$index == 6 && !editMode? '20%':$index == 6 && editMode? '25%':null"
                              [style.padding-left]="$index === 6 && !editMode? '8rem': $index < 6? '0.5rem': null"
                              [style.text-align]="$index === 6 && editMode?'center':null"
                              [class.dummy-cell]="column === 'dummy'">
                            @if (column === 'profile') {
                            <span [matTooltip]="getProfileInfoTooltip(detail.profileId)" matTooltipPosition="above">
                              {{getExpandedCellValue(element, column, detail)}}
                            </span>
                            } @else {
                            {{getExpandedCellValue(element, column, detail)}}
                            }
                          </div>
                          }
                        </div>
                      }
                    }
                    @else {
                      <div class="detail-flex-row detail-flex-header">
                                    @for (column of getExpandedColumns(element); track $index; let isLast = $last) {
                                    <div class="detail-col-header"
                                        [class.detail-col-first]="$index === 0"
                                        [class.flex-15]="$index > 0"
                                        [class.text-end]="$index > 3 && $index != 6"
                                        [style.flex-basis]="$index == 6? '20%':null"
                                        [style.padding-left]="$index === 6? '8rem': $index < 6? '0.5rem': null"
                                        [class.dummy-cell]="column === 'dummy'">
                                      {{getExpandedHeader(element, column)}}
                                    </div>
                                    }
                      </div>
                      @for (detail of getExpandedRows(element); track $index) {
                        <div class="detail-flex-row">
                          @for (column of getExpandedColumns(element); track $index; let isLast = $last) {
                          <div class="detail-col-cell"
                              [class.detail-col-first]="$index === 0"
                              [class.flex-15]="$index > 0"
                              [class.text-end]="$index > 3 && $index != 6"
                              [style.flex-basis]="$index == 6? '20%':null"
                              [style.text-align]="$index === 5? 'center':null"
                              [style.padding-left]="$index === 6? '8rem': $index < 6? '0.5rem': null"
                              [class.dummy-cell]="column === 'dummy'">
                            {{getExpandedCellValue(element, column, detail)}}
                          </div>
                          }
                        </div>
                      }
                    }

            </div>
            }
          </td>
        </ng-container>
      @if (!hasCosts) {
      <ng-container matColumnDef="dummy">
        <th class="flex-15  text-end th-custom" *matHeaderCellDef></th>
        <td class="flex-15  text-end td-custom" *matCellDef="let element"></td>
      </ng-container>
      <ng-container matColumnDef="dummy">
        <th class="flex-15  text-end th-custom" *matHeaderCellDef></th>
        <td class="flex-15  text-end td-custom" *matCellDef="let element"></td>
      </ng-container>
      }
      <ng-container matColumnDef="dummy">
        <th class="flex-15  text-end th-custom" *matHeaderCellDef></th>
        <td class="flex-15  text-end td-custom" *matCellDef="let element"></td>
      </ng-container>
      <ng-container matColumnDef="dummy">
        <th class="flex-15  text-end th-custom" *matHeaderCellDef></th>
        <td class="flex-15  text-end td-custom" *matCellDef="let element"></td>
      </ng-container>
      <ng-container matColumnDef="dummy">
        <th class="flex-15  text-end th-custom" *matHeaderCellDef></th>
        <td class="flex-15  text-end td-custom" *matCellDef="let element"></td>
      </ng-container>
      <ng-container matColumnDef="dummy">
        <th class="flex-15  text-end th-custom" *matHeaderCellDef></th>
        <td class="flex-15  text-end td-custom" *matCellDef="let element"></td>
      </ng-container>
      <ng-container matColumnDef="effort">
        <th class="flex-15  text-end th-custom text-size" [ngStyle]="{'margin-right': hasCosts ? 'auto' : null}" *matHeaderCellDef> {{variables.effort}} ({{variables.hours}})
        </th>
        <td class="flex-15  text-end td-custom" [ngStyle]="{'margin-right': hasCosts ? 'auto' : null}" *matCellDef="let element">
          {{element.name === this.variables.prodTools ? '-'+element.effort :  element.effort}}
        </td>
      </ng-container>
      @if (hasCosts) {
        <ng-container matColumnDef="profile">
          <th class="flex-20 th-custom text-size" style="padding-left: 8rem !important" *matHeaderCellDef> {{variables.profile}} {{variables.eurosPerHour}}</th>
          <td class="flex-20 td-custom" style="padding-left: 8rem !important" *matCellDef="let element">
           {{element.name === this.variables.riskOfProject ? variables.lowest +' '+ element.profile : variables.average +' '+ element.profile}}
          </td>
        </ng-container>
        <ng-container matColumnDef="cost">
          <th class="flex-15 text-end th-custom text-size" style="margin-right:auto" *matHeaderCellDef> {{variables.cost}} </th>
          <td class="flex-15 text-end td-custom" style="margin-right:auto" *matCellDef="let element">
            {{element.name === this.variables.prodTools ? '-'+element.cost :  element.cost}}
          </td>
        </ng-container>
      }
    <mat-header-row class="mat-header-row"
      *matHeaderRowDef="hasCosts ? totalDisplayedColumnsWithCost : totalDisplayedColumns"></mat-header-row>
    <mat-row class="mat-row-drop"
      *matRowDef="let row; columns: hasCosts ? totalDisplayedColumnsWithCost : totalDisplayedColumns;"
      [ngClass]="{ genericTotalRow: row?.id === 9, genericSubTotalRow: row?.id === 7, parentRowExpanded: isParentRowExpanded(row), parentColumnRow: [1, 2, 3, 4, 5, 6, 8].includes(row?.id) }"></mat-row>
    <mat-row *matRowDef="let row; columns: expandedDetailColumns;" class="detail-row"></mat-row>
    </mat-table>
  </div>
 
  <div class="estimate-result-export mt-3">
    <app-button
      typeBtn="secondary"
      style="display: flex; position: relative"
      (click)="exportExcel()"
      message="Excel"
      mat-icon-button
      matTooltip="{{ variables.exportExcel }}"
      icon="../../../../../assets/images/excel.svg"
      iconPosition="left"
      [addIconClasses]="false"
      width="200px"
    >
    </app-button>
  </div>
</div>
